import { render, staticRenderFns } from "./failureReportMsg.vue?vue&type=template&id=580386d2&scoped=true&"
import script from "./failureReportMsg.vue?vue&type=script&lang=js&"
export * from "./failureReportMsg.vue?vue&type=script&lang=js&"
import style0 from "./failureReportMsg.vue?vue&type=style&index=0&id=580386d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580386d2",
  null
  
)

export default component.exports